import ClientsAxios from "../../client-axios";
import { ResponseEntity } from "../../dto/response";

const { API_SERVER } = ClientsAxios;

export const GetCaptchImageService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.get('captcha/get', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const StoreDonerService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/donor-store', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const GetUserListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const GetAllUserListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/all-user-list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const GetUserDetailsService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/detail', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const setUserProfilePhotoService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/update-user-profile', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}


export const GetUserActivityService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/activity-log-list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const StoreGovDeptService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/gov-department/store', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const StoreImplementingAgencyService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/implementing-agency/store', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const GetPincodeDetailsService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('pincode-detail', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const UpdateUserStatusService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/update-status', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const UpdateUserRoleService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('roles/change', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const GetUserTypewiseCountService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/count', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const GetUserCountService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/register-count', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const GetStateListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('state-list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const GetDistrictListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('district-list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const VerifyTokenfUser = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/verify-token', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const SendMailOTP = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('verify-email', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const UpdateDonerService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/donor-update', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {

        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const VerifyMailOTP = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('verify-email/otp', payload);
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {

        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const UpdateImplementingAgencyService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/agency-update', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {

        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const UpdateUserprofileBankService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/update-user-profile', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {

        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const UpdateGovDeptService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/gov-update', payload, { headers: { 'Content-Type': 'multipart/form-data' } })
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const RoleListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('roles/list', payload )
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const RoleTypeListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('roles/roletype-list', payload )
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const DownloadUUserCsvService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('register/export', payload,{ responseType: 'blob' } )
        responseEntity.success(response.data, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data && response.data.message ? response.data.message : {})
    }
    return responseEntity
}

export const getPendingFromName = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('pending-from-user-list', payload )
        responseEntity.success(response.data, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data && response.data.message ? response.data.message : {})
    }
    return responseEntity
}

export const hitUserCount = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('visitor', payload )
        responseEntity.success(response.data, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data && response.data.message ? response.data.message : {})
    }
    return responseEntity
}

export const VisitUserCount = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('users-count', payload )
        responseEntity.success(response.data, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data && response.data.message ? response.data.message : {})
    }
    return responseEntity
}
